import React from "react";
import {Grid, Typography} from "@mui/material";
import GridCelulaEtapa from "./GridCelulaEtapa";


export interface GridLinhaDisciplinaProps {
    disciplina: any
}

const GridLinhaDisciplina = (p: GridLinhaDisciplinaProps) => {
 
    //console.log('GridLinhaDisciplinaProps', p);
    
    return (
        <React.Fragment>
            <Grid item container sx={{display:'flex', flexDirection:'row', flexWrap:'nowrap'}}>
                <Grid item container sx={{display:'flex', flexDirection:'row', width:'40%', borderWidth: '1px', borderColor: 'black', borderStyle: 'solid', borderRadius: '3px', padding:'3px'}}>
                   <Typography variant="body1" component="div" sx={{ fontWeight: 'normal' }}>{p.disciplina.disciplina}</Typography>
                </Grid>
                <Grid item container sx={{display:'flex', flexDirection:'row', flexWrap:'nowrap', width:'50%', justifyContent:'space-between'}}>
                    {
                        p.disciplina.modulos && p.disciplina.modulos.map( (m: any) => {
                            return (
                                <Grid item container>
                                    <GridCelulaEtapa etapa={m}/>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default (GridLinhaDisciplina);